// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"TaskStatusForm_formWrapper__30yPL","fieldWrap":"TaskStatusForm_fieldWrap__3QPMH"};